var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-store-component"},[_c('el-dialog',{attrs:{"title":_vm.$t('lcd.Devices.Display Info'),"visible":_vm.dialogVisible,"close-on-click-modal":false,"before-close":_vm.handleClose,"custom-class":"dialog-screen-display","width":"700px","append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticStyle:{"width":"656px","height":"656px","margin":"0 auto","display":"flex","justify-content":"center","align-items":"center"}},[_c('div',{staticClass:"currentPreview"},[(
            _vm.currentDisplayData.installType == 5002 ||
            _vm.currentDisplayData.installType == 5004
          )?_c('div',{staticClass:"preview800"},_vm._l((JSON.parse(
              _vm.currentDisplayData.bindTemplate
            )),function(item,index){return _c('div',{key:index},[(item.type == 'video')?_c('video',{staticClass:"previewVideo",style:({
                width: item.area.width / 2 + 'px',
                height: item.area.height / 2 + 'px',
                top: item.area.top / 2 + 'px',
                left: item.area.left / 2 + 'px',
                'z-index': item.area.height == 1280 ? 0 : 1,
              }),attrs:{"src":item.files[0].name,"autoplay":"","loop":""}}):_vm._e(),(item.type == 'img')?_c('el-image',{staticClass:"previewImg",style:({
                width: item.area.width / 2 + 'px',
                height: item.area.height / 2 + 'px',
                top: item.area.top / 2 + 'px',
                left: item.area.left / 2 + 'px',
              }),attrs:{"src":item.files[0].name,"fit":"contain"}}):_vm._e()],1)}),0):_vm._e(),(
            _vm.currentDisplayData.installType == 5001 ||
            _vm.currentDisplayData.installType == 5003
          )?_c('div',{staticClass:"preview1280"},_vm._l((JSON.parse(
              _vm.currentDisplayData.bindTemplate
            )),function(item,index){return _c('div',{key:index},[(item.type == 'video')?_c('video',{staticClass:"previewVideo",style:({
                width: item.area.width / 2 + 'px',
                height: item.area.height / 2 + 'px',
                top: item.area.top / 2 + 'px',
                left: item.area.left / 2 + 'px',
                'z-index': item.area.height == 1280 ? 0 : 1,
              }),attrs:{"src":item.files[0].name,"autoplay":"","loop":""}}):_vm._e(),(item.type == 'img')?_c('el-image',{staticClass:"previewImg",style:({
                width: item.area.width / 2 + 'px',
                height: item.area.height / 2 + 'px',
                top: item.area.top / 2 + 'px',
                left: item.area.left / 2 + 'px',
              }),attrs:{"src":item.files[0].name,"fit":"contain"}}):_vm._e()],1)}),0):_vm._e()])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }